<template>
<div>
    <!-- SUCCESSMODAL -->
    <div id="success" role="dialog" class="modal fade g-modal g-modal-confirmation" data-backdrop="static" aria-live="assertive" focusable="false">
        <div role="document" class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn btn-sm g-btn-icon g-btn-ui g-btn-ui-secondary modal-close" data-dismiss="modal" aria-label="Close"  @click.prevent="$parent.leaveAndInvalidate(true)">
                        <svg class="ico-delete" aria-hidden="false" focusable="false">
                            <use href="#ico-delete" xlink:href="#ico-delete" />
                        </svg>
                        <span>{{ $t('modals.close') }}</span>
                    </button>
                </div>
                <div class="modal-body text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="88" height="88" viewBox="0 0 88 88" focusable="false">
                        <defs>
                            <path id="icon_success_green_web_mobile-a" d="M43.75,0 C67.9005932,0 87.5,19.5994068 87.5,43.75 C87.5,67.9005932 67.9005932,87.5 43.75,87.5 C19.5994068,87.5 0,67.9005932 0,43.75 C0,19.5994068 19.5994068,0 43.75,0 Z M43.75,4.16666667 C21.9005932,4.16666667 4.16666667,21.9005932 4.16666667,43.75 C4.16666667,65.5994068 21.9005932,83.3333333 43.75,83.3333333 C65.5994068,83.3333333 83.3333333,65.5994068 83.3333333,43.75 C83.3333333,21.9005932 65.5994068,4.16666667 43.75,4.16666667 Z M60.8942246,27.8393524 C61.62728,26.9525071 62.940469,26.8278358 63.8273142,27.5608913 C64.7141595,28.2939467 64.8388308,29.6071356 64.1057754,30.4939809 L39.9969667,59.6606476 C39.2170183,60.6042236 37.7954906,60.6751432 36.9254994,59.8138823 L23.5343082,46.5570698 C22.7166235,45.7475905 22.7099718,44.4285136 23.5194511,43.610829 C24.3289303,42.7931444 25.6480072,42.7864926 26.4656918,43.5959719 L38.2373392,55.2494924 L60.8942246,27.8393524 Z"/>
                        </defs>
                        <use fill="#01B25A" xlink:href="#icon_success_green_web_mobile-a"/>
                    </svg>
                </div>
                <div class="modal-body g-modal-body-large text-center pb-0">
                    <h5 class="modalTitle">{{ $t('modals.success.title') }}</h5>
                    <p class="modalCaption" v-html="$t('modals.success.caption')"></p>
                </div>
                <div class="modal-footer">
                    <button type="button" @click.prevent="$parent.leaveAndInvalidate(true)" class="btn g-btn-primary p-3">
                        <span>{{ $t('modals.success.button') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- -->

    <!-- PROCESSMODAL -->
    <div id="process" role="dialog" class="modal g-modal g-modal-confirmation process-modal" data-backdrop="static" aria-live="assertive">
        <div role="document" class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                </div>
                <div class="modal-body text-center">
                    <em class="g-spinner" aria-live="polite" aria-busy="true"><span class="visually-hidden">{{ $t('modals.process.title') }}</span><i></i><i></i><i></i><i></i><i></i></em>
                </div>
                <div class="modal-body g-modal-body-large text-center">
                    <h5 class="modalTitle">{{ $t('modals.process.title') }}</h5>
                    <p class="text-xs-center modalCaption">{{ $t('modals.process.caption') }}</p>
                </div>
            </div>
        </div>
    </div>
    <!-- -->

    <!-- FAILEDMODAL -->
    <div id="failed" role="dialog" class="modal fade g-modal g-modal-confirmation" data-backdrop="static" aria-live="assertive">
        <div role="document" class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body text-center">

                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="88" height="88" viewBox="0 0 88 88" focusable="false" v-if="!subtype">
                        <defs>
                            <path id="icon_error_red_web_mobile-a" d="M43.75,46.6962783 L28.5564725,61.8898058 C27.7428802,62.7033981 26.4237865,62.7033981 25.6101942,61.8898058 C24.7966019,61.0762135 24.7966019,59.7571198 25.6101942,58.9435275 L40.8037217,43.75 L25.6101942,28.5564725 C24.7966019,27.7428802 24.7966019,26.4237865 25.6101942,25.6101942 C26.4237865,24.7966019 27.7428802,24.7966019 28.5564725,25.6101942 L43.75,40.8037217 L58.9435275,25.6101942 C59.7571198,24.7966019 61.0762135,24.7966019 61.8898058,25.6101942 C62.7033981,26.4237865 62.7033981,27.7428802 61.8898058,28.5564725 L46.6962783,43.75 L61.8898058,58.9435275 C62.7033981,59.7571198 62.7033981,61.0762135 61.8898058,61.8898058 C61.0762135,62.7033981 59.7571198,62.7033981 58.9435275,61.8898058 L43.75,46.6962783 Z M43.75,0 C67.9005932,0 87.5,19.5994068 87.5,43.75 C87.5,67.9005932 67.9005932,87.5 43.75,87.5 C19.5994068,87.5 0,67.9005932 0,43.75 C0,19.5994068 19.5994068,0 43.75,0 Z M43.75,4.16666667 C21.9005932,4.16666667 4.16666667,21.9005932 4.16666667,43.75 C4.16666667,65.5994068 21.9005932,83.3333333 43.75,83.3333333 C65.5994068,83.3333333 83.3333333,65.5994068 83.3333333,43.75 C83.3333333,21.9005932 65.5994068,4.16666667 43.75,4.16666667 Z"/>
                        </defs>
                        <use fill="#F55" xlink:href="#icon_error_red_web_mobile-a"/>
                    </svg>
                    <svg width="88" height="88" viewBox="0 0 88 88" focusable="false" v-if="subtype === 'warn'">
                        <use fill="#005B94" href="#ico-warning" xlink:href="#ico-warning"></use>
                    </svg>

                </div>
                <div class="modal-body g-modal-body-large text-center modal-body-failed">
                    <h5 class="modalTitle">{{ $t('modals.failed.title') }}</h5>
                    <p class="text-xs-center modalCaption">{{ $t('modals.failed.caption') }}</p>
                    <p class="text-xs-center modalErrorId"></p>
                </div>
                <div class="modal-footer condReturn">
                    <button type="button" @click.prevent="$parent.leaveAndInvalidate(false)" class="btn btn-lg g-btn-primary p-3">
                        <span>{{ $t('modals.failed.button') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- -->

    <!-- INCORRECT MERCHANT CHECK -->
    <div id="preventreturn" role="dialog" data-bs-backdrop="static" class="modal fade g-modal g-modal-confirmation" data-backdrop="static" aria-live="assertive">
        <div role="document" class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body text-center">

                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="88" height="88" viewBox="0 0 88 88" focusable="false" v-if="!subtype">
                        <defs>
                            <path id="icon_error_red_web_mobile-a" d="M43.75,46.6962783 L28.5564725,61.8898058 C27.7428802,62.7033981 26.4237865,62.7033981 25.6101942,61.8898058 C24.7966019,61.0762135 24.7966019,59.7571198 25.6101942,58.9435275 L40.8037217,43.75 L25.6101942,28.5564725 C24.7966019,27.7428802 24.7966019,26.4237865 25.6101942,25.6101942 C26.4237865,24.7966019 27.7428802,24.7966019 28.5564725,25.6101942 L43.75,40.8037217 L58.9435275,25.6101942 C59.7571198,24.7966019 61.0762135,24.7966019 61.8898058,25.6101942 C62.7033981,26.4237865 62.7033981,27.7428802 61.8898058,28.5564725 L46.6962783,43.75 L61.8898058,58.9435275 C62.7033981,59.7571198 62.7033981,61.0762135 61.8898058,61.8898058 C61.0762135,62.7033981 59.7571198,62.7033981 58.9435275,61.8898058 L43.75,46.6962783 Z M43.75,0 C67.9005932,0 87.5,19.5994068 87.5,43.75 C87.5,67.9005932 67.9005932,87.5 43.75,87.5 C19.5994068,87.5 0,67.9005932 0,43.75 C0,19.5994068 19.5994068,0 43.75,0 Z M43.75,4.16666667 C21.9005932,4.16666667 4.16666667,21.9005932 4.16666667,43.75 C4.16666667,65.5994068 21.9005932,83.3333333 43.75,83.3333333 C65.5994068,83.3333333 83.3333333,65.5994068 83.3333333,43.75 C83.3333333,21.9005932 65.5994068,4.16666667 43.75,4.16666667 Z"/>
                        </defs>
                        <use fill="#F55" xlink:href="#icon_error_red_web_mobile-a"/>
                    </svg>
                    <svg width="88" height="88" viewBox="0 0 88 88" focusable="false" v-if="subtype === 'warn'">
                        <use fill="#005B94" href="#ico-warning" xlink:href="#ico-warning"></use>
                    </svg>

                </div>
                <div class="modal-body g-modal-body-large text-center modal-body-prevent_return">
                    <h5 class="modalTitle">{{ $t('modals.preventReturn.title') }}</h5>
                    <p class="text-xs-center modalCaption">{{ $t('modals.preventReturn.caption') }}</p>
                    <p class="text-xs-center modalErrorId"></p>
                </div>
                <div class="modal-footer condReturn">
                    <a type="button" @click.prevent="redirectToFailedMerchantCheckUrl()" class="btn btn-lg g-btn-primary p-3">
                        <span>{{ $t('modals.preventReturn.button') }}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!-- -->

</div>
</template>

<script>

    export default {

        name: 'Modal',

        data() {
            return {
                subtype: '',
                subtypes: {
                    warn: 'failed',
                },
            }
        },

        methods: {

            /**
             * Show modal and set it's value.
             *
             * @param type - Type of modal, error success or other
             * @param fatal - If modaal is terminal or not
             * @param texts - Translations node
             *
             * @returns Operation status
             */
            show(type, fatal, {title, caption, translate, errorId = ''} = {}) {

                // Subtype category system.
                if (Object.keys(this.subtypes).includes(type)) {
                    this.subtype = type;
                    type = this.subtypes[type];
                } else {
                    this.subtype = '';
                }

                // Element id is same as type, so we can use it as selector.
                let node = $('#' + type);

                if (type === 'sign') {
                    node.modal('show');
                    this.$parent.$refs.pageSigning.disableBackgroundSelection();
                    return true;
                }

                // Fatal flag indicates window with no possible actions.
                if (fatal === true) {
                    node.find('.condReturn').remove();
                } else {
                    if (type === 'failed') {
                        $('.modal-body-failed').css({paddingBottom: 0});
                    }
                }

                if (translate !== 'generic') {
                    title = (typeof translate === 'undefined' || !translate) ? title : this.$t(title);
                    caption = (typeof caption === 'undefined' || !translate) ? caption : this.$t(caption);

                // Generic texts are generated to save space when calling function.
                } else {
                    title = this.$t('modals.' + type + '.title'),
                    caption = this.$t('modals.' + type + '.caption')
                }

                node.find('.modalTitle').html(title);
                node.find('.modalCaption').html(caption);
                if (errorId) node.find('.modalErrorId').html(`${this.$t('modals.failed.errorIdLabel')} ${errorId}`);
                node.modal('show');
                this.$parent.$refs.pageSigning.disableBackgroundSelection();
            },

            /**
             * Hide modal and keep original value set.
             *
             * @param type - Particular modal type
             */
            hide(type) {
                $('#' + type).modal('hide');
                this.$parent.$refs.pageSigning.enableBackgroundSelection();
            },

            async redirectToFailedMerchantCheckUrl() {
                // Log data.
                await this.$parent.genericLogger("redirect to merchant check failed url");

                // Before redirecting wait for token invalidation.
                await this.$api.invalidateToken();

                // Finally leave.
                location.href = this.$t('modals.preventReturn.buttonUrl');
            }
        }
    };

</script>

<style>
</style>
